import { OVERRIDE_MACHEMETRY_IDS_FOR_OTHER_PROCESSES_PNL_CHART } from "constants/customers";
import { UPDATE_FULL_RANGE_DATA_DUMP_FOR_SUBORDINATE_PROCESSES } from "providers/GlobalStateProvider";
import DataDumpGetter from "segments/DataDumpGetter/DataDumpGetter";
import {
  useFocusRange,
  useLeaderProcessId,
  useSelectedProcesses,
  useVisibleGroups,
  useVisibleProcessIds,
} from "utils/customHooks/genericHooks";
import { useCustomerKey } from "utils/customHooks/useCustomerKey";
import { useFlightConfig } from "./FlightConfig/useFlightConfig";

/** fetch a single DDA for all "subordinate" (non-serial) processes */
export function DataDumpGetterForFullRangeSubordinateProcesses() {
  const cKey = useCustomerKey();
  const focusRange = useFocusRange();
  const visibleProcessIds = useVisibleProcessIds();
  const selectedProcessIdsRef = useSelectedProcesses();
  const visibleGroups = useVisibleGroups();

  // Should only be one group shown on timeline page
  const groupForTimelinePage = visibleGroups?.[0]?.summaryGroup;

  let subordinateProcessIds = visibleProcessIds.filter(
    id => !selectedProcessIdsRef.current.includes(id)
  );

  // If leader/follower config + enableSecondaryProcessesPnlChart, show all non-leader processes
  const [
    {
      general: { enableSecondaryProcessesPnlChart },
    },
  ] = useFlightConfig();
  const leaderProcessId = useLeaderProcessId();
  if (leaderProcessId && enableSecondaryProcessesPnlChart) {
    subordinateProcessIds = visibleProcessIds.filter(
      id => id !== leaderProcessId
    );
  }

  // Override subordinate processes
  const overridenOtherProcessesPnlChartMachines =
    OVERRIDE_MACHEMETRY_IDS_FOR_OTHER_PROCESSES_PNL_CHART?.[cKey]?.[
      groupForTimelinePage
    ];

  return (
    <DataDumpGetter
      timeRange={focusRange}
      processIds={
        overridenOtherProcessesPnlChartMachines ?? subordinateProcessIds
      }
      dataDumpAggType={UPDATE_FULL_RANGE_DATA_DUMP_FOR_SUBORDINATE_PROCESSES}
    />
  );
}
